import React, {FC} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../libs/shared/ui/src/styles/mixins';
import {addCellsCommonStyles, makeCellClassName} from '../../components/inboxes/cells/cellBaseCommon';
import {CellDate} from '../../components/inboxes/cells/content/cell/cellDate';
import {CellsItemsClickEventHandler} from '../../components/inboxes/cells/content/cellsItemsBase';

interface AuditTrailActivityCellProps {
  displayActivity: {
    activityId: number;
    conversationId: number;
    date: number;
    title: string;
    body: string;
  };
  isSelected: boolean;
  onClick: CellsItemsClickEventHandler<number>;
  onDoubleClick: (arg: number) => void;
}

/*
 * Styles.
 */

interface CellBaseProps {
  $isSelected: boolean;
}

const StyledActivityCellDiv = styled.div<CellBaseProps>`
  background-color: white;
  border-radius: 5px;
  padding: 10px;
  margin: 8px 8px 0 14px;
  height: 55px;
  gap: 3px;
  display: flex;
  flex-direction: column;
  color: ${(p) => (p.$isSelected ? p.theme.invertedText : p.theme.greys.shade90)};

  ${() => addCellsCommonStyles(false)}
`;

const StyledActivityTopLine = styled.div`
  display: flex;
`;
const StyledFromSpan = styled.span`
  flex: 1;
  font-weight: ${fontWeights.semibold};
  ${ellipsis()};
`;
const StyledActivityBottomLine = styled.div`
  ${ellipsis()};
`;

/*
 * Component.
 */

export const AuditTrailCell: FC<AuditTrailActivityCellProps> = (props) => {
  const {displayActivity, isSelected, onClick, onDoubleClick} = props;
  const {activityId, conversationId, date, title, body} = displayActivity;

  const className = makeCellClassName('audit-trail-cell', isSelected);
  return (
    <StyledActivityCellDiv
      $isSelected={isSelected}
      key={activityId}
      onClick={(event) => onClick(activityId, event)}
      onDoubleClick={() => onDoubleClick(conversationId)}
      className={className}
    >
      <StyledActivityTopLine>
        <StyledFromSpan>{title}</StyledFromSpan>
        <CellDate
          date={date}
          isSelected={isSelected}
          reminderDate={undefined}
          slaTimerDate={undefined}
          waitingSinceMs={undefined}
        />
      </StyledActivityTopLine>
      <StyledActivityBottomLine>{body}</StyledActivityBottomLine>
    </StyledActivityCellDiv>
  );
};
